<template>
  <div>
    <div class="bold fs22 pdBtm20 mrBtm20 borBtmdd">资料上传</div>
    <!--上传-->
    <div class="dif">
      <div class="difcc" v-for="(item,index) in 4" :key="index">
        <el-upload
            class="upLoad_warp"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="onsuccess">
          <div class="difcc">
            <div class="upLoad difcc">
              <i class="el-icon-plus fs30 bold" style="color: rgba(0, 0, 0, 0.45);"></i>
              <p class="fs12 mrTop10" style="color: rgba(0, 0, 0, 0.65);">上传照片</p>
            </div>
            <div class="mrTop10 fs14 col101010">考试成绩</div>
          </div>
        </el-upload>
      </div>
    </div>
    <div class="button difcac colfff">立即上传</div>
    <!--已上传-->
    <div style="margin-bottom: 4.5rem;">
      <div class="bold fs22 pdBtm20 mrBtm20" style="color: #07838D">已上传</div>
      <div class="dif">
        <div class="difcc" v-for="(item,index) in 4" :key="index">
          <div class="difcc upLoad_warp">
            <div class="upLoad difcc">

            </div>
            <div class="mrTop10 fs14 col101010">考试成绩</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "upLoadInfo",
  data() {
    return {

    }
  },
  methods: {
    onsuccess() {},

  }
}
</script>

<style scoped>
  .upLoad_warp{
    margin-right: 3.4rem;
  }
  .upLoad{
    width: 10rem;
    height: 10rem;
    background-color: rgba(0, 0, 0, 0.02);
    cursor: pointer;
  }
  .button{
    width: 40rem;
    height: 4.5rem;
    font-size: 1.4rem;
    background: #e17835;
    margin: 10rem auto;
    cursor: pointer;
  }
</style>